import { PayrollCustomFieldDefinition } from 'api/gql-utils/employeeDataSettings/types';
import { PayrollFieldViolation } from 'api/gql-utils/employeeCustomFields/types';

export type EffectiveAccess = 'EDIT' | 'VIEW' | 'HIDDEN';

export type CustomFieldValueMap = Record<string, string | null>;

export type AccessedFieldDefinition = PayrollCustomFieldDefinition & {
  effectiveAccess: EffectiveAccess;
};

export type CanonicalValueType =
  | 'STRING'
  | 'INTEGER'
  | 'DECIMAL'
  | 'CURRENCY'
  | 'DATE'
  | 'BOOLEAN'
  | 'ENUM'
  | 'FILE';

// HRIS stores/returns the proto vocabulary (INT/FLOAT/MONEY/BOOL) while the
// settings UI uses INTEGER/DECIMAL/CURRENCY/BOOLEAN. Normalize both so field
// renderers never fall through to a text input for a known type.
const VALUE_TYPE_ALIASES: Record<string, CanonicalValueType> = {
  STRING: 'STRING',
  INT: 'INTEGER',
  INTEGER: 'INTEGER',
  FLOAT: 'DECIMAL',
  DECIMAL: 'DECIMAL',
  MONEY: 'CURRENCY',
  CURRENCY: 'CURRENCY',
  DATE: 'DATE',
  BOOL: 'BOOLEAN',
  BOOLEAN: 'BOOLEAN',
  ENUM: 'ENUM',
  FILE: 'FILE',
};

export const canonicalValueType = (valueType?: string | null): CanonicalValueType =>
  VALUE_TYPE_ALIASES[(valueType ?? '').toUpperCase()] ?? 'STRING';

export type CustomFieldsDisplayProps = {
  definitions: AccessedFieldDefinition[];
  values: CustomFieldValueMap;
};

export type CustomFieldChangeHandler = (fieldKey: string, value: string | null) => void;

export type CustomFieldInputProps = {
  def: AccessedFieldDefinition;
  value: string | null;
  onChange: CustomFieldChangeHandler;
  errorText?: string;
};

export type EmployeeOtherInfoWidgetProps = {
  userId: number;
};

export type CustomFieldsFormProps = {
  definitions: AccessedFieldDefinition[];
  values: CustomFieldValueMap;
  onChange: CustomFieldChangeHandler;
  violations: PayrollFieldViolation[];
  showViewFieldsReadOnly: boolean;
};
